/**
 * Owner switch that opens/closes the partner panel (apps/api partner-panel,
 * setting `features.partner_panel_open`). Shared by the API (503 body) and the
 * partner panel (closed screen).
 */
export const PARTNER_PANEL_CLOSED = 'partner_panel_closed' as const;

/** Shown to affiliates when the owner left `features.partner_closed_message` empty. */
export const PARTNER_PANEL_CLOSED_DEFAULT_MESSAGE =
  'در حال آماده‌سازی برنامهٔ تازهٔ بازاریابی میزبان‌فا هستیم. درآمدها و معرفی‌های قبلی شما محفوظ است و ثبت فروش‌های تازه هم ادامه دارد؛ به‌زودی همین‌جا در دسترس خواهد بود.';

/**
 * 403 body of every write while an admin views a partner's panel (apps/api impersonation): the
 * view is read-only. The partner panel shows one friendly toast for it.
 */
export const IMPERSONATION_READ_ONLY = 'impersonation_read_only' as const;
export const IMPERSONATION_READ_ONLY_MESSAGE = 'در حالت مشاهده توسط مدیر، امکان تغییر نیست.';

export interface ImpersonationReadOnlyError {
  error: typeof IMPERSONATION_READ_ONLY;
  message: string;
}
